import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditServiceCategory from './EditServiceCategory'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'
import ServiceCategoryNotFound from './ServiceCategoryNotFound'

import Resource from '../../stores/resource'
const CategoryStore = Resource('service-categories')

class EditServiceCategoryPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      serviceCategory: {},
      error: '',
      loading: true
    }
  }

  componentDidMount() {
    CategoryStore.find(this.props.match.params.id)
    .then((result) => this.setState({serviceCategory: result.data, loading: false}))
    .catch((error) => this.setState({serviceCategory: {}, error: errors.unpack(error), loading: false}))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      loading,
      error,
      serviceCategory
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(serviceCategory)) return <ServiceCategoryNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Edit Service category
          </PageTitle>
        </header>

        <EditServiceCategory serviceCategory={serviceCategory} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditServiceCategoryPage



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/EditServiceCategoryPage.jsx